import { Component, ElementRef, Injector, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { AppConfig } from '../../../../../app.config';
import { ConnectionService } from '../../../../../../services/connection-service';
import { NgForm } from '@angular/forms';

@Component({
  selector: 'follow-up-sop-history',
  templateUrl: './follow-up-sop-history.html',
  providers: [NgForm],
  standalone: false
})
export class FollowUpSopHistoryComponent {
  regimen: any;
  loading: boolean;
  regimenHistory: Array<{ [key: string]: unknown }> = [];

  @ViewChild('historyList', { static: false }) historyList: ElementRef;

  constructor(
    public readonly dialogRef: MatDialogRef<FollowUpSopHistoryComponent>,
    public readonly injector: Injector,
    public readonly appConfig: AppConfig,
    private readonly conn: ConnectionService) {
    const data = this.injector.get(MAT_DIALOG_DATA);
    this.regimen = data.regimen;
    this.loading = true;

  }
  async ngOnInit(): Promise<void> {
    console.log(this.regimen);
    await this.loadRegimenHistory();
  }

  async hideModal(): Promise<any> {
    this.dialogRef.close();
  }

  async loadRegimenHistory(): Promise<void> {
    const regimenHistory: Array<Table.RegimenHistory> = await this.conn.findRegimenHistory({
      where: { regimen: this.regimen, followUpSop: { $exists: true } },
      limit: 10,
      skip: this.regimenHistory.length,
      descending: 'createdAt',
      include: ['byUser'],
      project: ['followUpSop', 'byUser.username' as 'byUser'],
    });
    console.log(regimenHistory);
    this.regimenHistory = [...this.regimenHistory, ...regimenHistory.map((each: any) => each.toJSON())];
    this.loading = false;
  }

  private isScrolledToBottom(elementRef: ElementRef): boolean {
    const element = elementRef.nativeElement;
    const distanceBtwBottom = Math.abs((element.scrollHeight - element.scrollTop) - element.clientHeight);
    return distanceBtwBottom < 50;
  }

  async onScrollList(): Promise<void> {
    console.log(this.isScrolledToBottom(this.historyList));
    const isAtBottom = this.isScrolledToBottom(this.historyList);
    if (isAtBottom) {
      await this.loadRegimenHistory();
    }
  }
}
